import { z } from 'zod';

import { captureSentryException } from 'shared/utils';

import {
  RESET_PASSWORD_FEATURE_TAG,
  RESET_PASSWORD_SERVER_FIELDS,
  RESET_PASSWORD_VALIDATION_ERROR_CODES
} from '../consts';

const ResetPasswordServerErrorPayloadSchema = z.object({
  fields: z.record(
    z.nativeEnum(RESET_PASSWORD_SERVER_FIELDS),
    z.array(z.nativeEnum(RESET_PASSWORD_VALIDATION_ERROR_CODES))
  )
});

/** Extracts field errors from the reset-password API 400 payload (`{ code, fields }`) into a flat array. */
export const mapResetPasswordServerErrorsToFieldErrors = (error: unknown) => {
  const result = ResetPasswordServerErrorPayloadSchema.safeParse(error);

  if (!result.success) {
    captureSentryException({
      message: 'Unrecognised reset-password validation error',
      feature: RESET_PASSWORD_FEATURE_TAG,
      error,
      extra: { method: 'mapResetPasswordServerErrorsToFieldErrors', zodErrors: result.error.flatten() }
    });

    return [];
  }

  const { fields } = result.data;
  const fieldValues = Object.values(RESET_PASSWORD_SERVER_FIELDS);

  return fieldValues.flatMap((field) => (fields[field] ?? []).map((code) => ({ field, code })));
};
